import QuoteForm from '../components/Quote/QuoteForm';

export default function QuotePage({ quoteSubmitted, setQuoteSubmitted, isLoading, setIsLoading }) {
  return (
    <div className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">Get a Project Quote</h1>
            <p className="text-xl text-gray-600">Fill out the form below to receive a customized quote for your project. Our team will review your requirements and get back to you within 24 hours.</p>
          </div>
          <QuoteForm 
            quoteSubmitted={quoteSubmitted} 
            setQuoteSubmitted={setQuoteSubmitted}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        </div>
      </div>
    </div>
  );
}